import { render, staticRenderFns } from "./ePharmacyItemsReceived.vue?vue&type=template&id=4e480e78&"
import script from "./ePharmacyItemsReceived.vue?vue&type=script&lang=js&"
export * from "./ePharmacyItemsReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports